import React from 'react';
import { Grid, Button } from '@mui/material';
import StyledBox from 'views/rebranded-module/common/components/Logical/TourWidgetV2/TourWidgetV2.styles';
import { TourWidgetField } from 'views/rebranded-module/common/components/Logical/MainWidgetV2/components/TourWidgetField';
import ToursIcon from 'views/common/components/UI/Icons/ToursIcon';
import LocationsIcon from 'views/common/components/UI/Icons/LocationsIcon';
import ToursNameIcon from 'views/common/components/UI/Icons/ToursNameIcon';
import { TOUR_WIDGET_FIELDS } from 'lib/utils/mainWidgetConstants';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const TourWidgetV2 = (props) => {
  const {
    tourTypesList,
    countriesList,
    statesList,
    handleSelectInputChange,
    selectedOptions,
    handleSearchButtonClick,
  } = props;

  const content = useContent('TourWidgetComponent');
  const getFieldValue = (options, selectedOptionField) => options.find(
    (option) => option.id === selectedOptions[selectedOptionField]?.id,
  ) || null;

  return (
    <StyledBox>
      <Grid container spacing={0.1} className="TWV2Grid">
        <Grid item xs={12} md={6} lg={3}>
          <TourWidgetField
            icon={<ToursIcon />}
            options={tourTypesList}
            label={content.tourTypeFieldLabel}
            dataTestIdPrefix="tour-widget-type"
            value={getFieldValue(tourTypesList, TOUR_WIDGET_FIELDS.TOUR_TYPE)}
            onChange={(...args) => {
              handleSelectInputChange(TOUR_WIDGET_FIELDS.TOUR_TYPE, ...args);
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <TourWidgetField
            icon={<LocationsIcon />}
            options={countriesList}
            label={content.countryFieldLabel}
            placeholder={content.countriesFieldPlaceholder}
            dataTestIdPrefix="tour-widget-country"
            value={getFieldValue(countriesList, TOUR_WIDGET_FIELDS.COUNTRY)}
            onChange={(...args) => {
              handleSelectInputChange(TOUR_WIDGET_FIELDS.COUNTRY, ...args);
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <TourWidgetField
            icon={<ToursNameIcon />}
            options={statesList}
            label={content.stateNameFieldLabel}
            placeholder={content.statesFieldPlaceholder}
            dataTestIdPrefix="tour-widget-state"
            value={getFieldValue(statesList, TOUR_WIDGET_FIELDS.STATE)}
            onChange={(...args) => handleSelectInputChange(TOUR_WIDGET_FIELDS.STATE, ...args)}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Button
            variant="contained"
            color="primary"
            className="TWV2CheckAvBtn"
            data-testid="tour-widget-check-availability"
            onClick={handleSearchButtonClick}>
            {content.checkAvailabilityButtonText}
          </Button>
        </Grid>
      </Grid>
    </StyledBox>
  );
};

export { TourWidgetV2 };
